import { render, staticRenderFns } from "./acctovar.vue?vue&type=template&id=2dbf57e5&"
import script from "./acctovar.vue?vue&type=script&lang=js&"
export * from "./acctovar.vue?vue&type=script&lang=js&"
import style0 from "./acctovar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports